export default ({ commit }, payload) => {
	console.info('🎬 setSignInState', payload);
	commit('SET_SIGNED_IN_STATE', payload);
};
